import * as React from 'react';
import { RouteComponentProps, Redirect } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import Select from 'react-select';
import { Heading } from './NavMenu';
import { UserState, ReportsState, ValueLabel } from '../interface/MyInterfaces'

import {
    handleReportDisplayIdChange_ECR,
    handleReportDisplayIdChange_FactSheet,
    handleReportDisplayIdChange_FactSheet_Detail,
    handleReportDisplayIdChange_SpendingReport,
    handleReportDisplayIdChange_impactFinder,
    handleReportDisplayIdChange_EmployeeReport,
    handleReportDisplayIdChange_VendorReport,
    handleReportDisplayIdChange_CTSAReport,
    handleReportDisplayIdChange_StateReport,
    handleReportDisplayIdChange,
    loadShareHistory
} from '../actions/UserActions';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ApplicationState } from '../reducers/Index';
import { SharedLinksList } from './SharedLinksList';

//const hashids = new Hashids('impact finder', 6);

class Reports extends React.Component<ReportsState, {}> {
    constructor(props) {
        super(props);
    }
    
    componentDidMount() {
        this.props.loadShareHistory(this.props.UserState.display_id, this.props.UserState.username);
    }

    componentDidUpdate(prevProps, prevState) {
        //if (this.props.UserState.qa_account != "Y" && this.props.UserState.report_display_id != this.props.UserState.display_id) {
        //    const { display_id, report_university_name_initial } = this.props.UserState;
        //    this.props.handleReportDisplayIdChange(display_id, report_university_name_initial);
        //}
    }
    
    getUniversityListECR() {
        let the_list: Array<ValueLabel>
        the_list = new Array<ValueLabel>();
        if (this.props.UserState.UniversityListECR !== undefined) {
            //the_list.push({ value: 0, label: "Select University", isDisabled: false });
            this.props.UserState.UniversityListECR.forEach(x => {
                if (this.props.UserState["qa_account"] === "Y" || this.props.UserState.display_id == x.display_id || (x.detail_ids !== undefined && x.detail_ids != null && x.detail_ids.includes(this.props.UserState.display_id)))
                    the_list.push({ value: +x.display_id, label: x.the_university.replace("the ", ""), isDisabled: false });
            })
        }
        return sortUniversity(the_list);
    }

    getUniversityListImpactFinder() {
        let the_list: Array<ValueLabel>
        the_list = new Array<ValueLabel>();
        if (this.props.UserState.UniversityListImpactFinder !== undefined) {
            this.props.UserState.UniversityListImpactFinder.forEach(x => {
                if (this.props.UserState["qa_account"] === "Y" || this.props.UserState.display_id == x.display_id || (x.detail_ids !== undefined && x.detail_ids != null && x.detail_ids.includes(this.props.UserState.display_id))) {
                    the_list.push({ value: +x.display_id, label: x.the_university.replace("the ", ""), isDisabled: false });
                }
            })
        }
        return sortUniversity(the_list);
    }

    getUniversityListSpendingReport() {
        //this.props.UserState["qa_account"] === "Y"
        let the_list: Array<ValueLabel>
        the_list = new Array<ValueLabel>();
        if (this.props.UserState.UniversityListSpendingReport !== undefined) {
            //the_list.push({ value: 0, label: "Select University", isDisabled: false });
            this.props.UserState.UniversityListSpendingReport.forEach(x => {
                if (this.props.UserState["qa_account"] === "Y" || this.props.UserState.display_id == x.display_id || (x.detail_ids !== undefined && x.detail_ids != null && x.detail_ids.includes(this.props.UserState.display_id))) {
                    the_list.push({ value: +x.display_id, label: x.the_university.replace("the ", ""), isDisabled: false });
                }
            })
        }
        return sortUniversity(the_list);
    }

    getUniversityListStateReport() {
        let the_list: Array<ValueLabel>
        the_list = new Array<ValueLabel>();
        if (this.props.UserState.UniversityListStateReport !== undefined) {
            //the_list.push({ value: 0, label: "Select University", isDisabled: false });
            this.props.UserState.UniversityListStateReport.forEach(x => {
                if (this.props.UserState["qa_account"] === "Y" || this.props.UserState.display_id == x.display_id || (x.detail_ids !== undefined && x.detail_ids != null && x.detail_ids.includes(this.props.UserState.display_id)))
                    the_list.push({ value: +x.display_id, label: x.the_university.replace("the ", ""), isDisabled: false });
            })
        }
        return sortUniversity(the_list);

    }

    getUniversityListVendorReport() {
        let the_list: Array<ValueLabel>
        the_list = new Array<ValueLabel>();

        if (this.props.UserState.UniversityListVendorReport !== undefined) {
            this.props.UserState.UniversityListVendorReport.forEach(x => {
                if (this.props.UserState["qa_account"] === "Y" || this.props.UserState.display_id == x.display_id || (x.detail_ids !== undefined && x.detail_ids != null && x.detail_ids.includes(this.props.UserState.display_id)))
                    the_list.push({ value: +x.display_id, label: x.the_university.replace("the ", ""), isDisabled: false });
            })
        }
        return sortUniversity(the_list);
    }


    getUniversityListEmployeeReport() {
        let the_list: Array<ValueLabel>
        the_list = new Array<ValueLabel>();
        if (this.props.UserState.UniversityListSBEmployeeReport !== undefined) {
            this.props.UserState.UniversityListSBEmployeeReport.forEach(x => {
                if (this.props.UserState["qa_account"] === "Y" || this.props.UserState.display_id == x.display_id || (x.detail_ids !== undefined && x.detail_ids != null && x.detail_ids.includes(this.props.UserState.display_id)))
                    the_list.push({ value: +x.display_id, label: x.the_university.replace("the ", ""), isDisabled: false });
            })
        }
        return sortUniversity(the_list);
    }

    getUniversityListSBEmployeeReport() {
        let the_list: Array<ValueLabel>
        the_list = new Array<ValueLabel>();

        if (this.props.UserState.UniversityListSBEmployeeReport !== undefined) {
            this.props.UserState.UniversityListSBEmployeeReport.forEach(x => {
                if (this.props.UserState["qa_account"] === "Y" || this.props.UserState.display_id == x.display_id || (x.detail_ids !== undefined && x.detail_ids != null && x.detail_ids.includes(this.props.UserState.display_id)))
                    the_list.push({ value: +x.display_id, label: x.the_university.replace("the ", ""), isDisabled: false });
            })
        }
        return sortUniversity(the_list);
    }

    getUniversityListCTSAReport() {
        let the_list: Array<ValueLabel>
        the_list = new Array<ValueLabel>();

        if (this.props.UserState.UniversityListCTSAReport !== undefined) {
            this.props.UserState.UniversityListCTSAReport.forEach(x => {
                if (this.props.UserState["qa_account"] === "Y" || this.props.UserState.display_id == x.display_id || (x.detail_ids !== undefined && x.detail_ids != null && x.detail_ids.includes(this.props.UserState.display_id)))
                    the_list.push({ value: +x.display_id, label: x.the_university.replace("the ", ""), isDisabled: false });
            })
        }
        return sortUniversity(the_list);
    }
    
    getDetailedDistrictList() {
        let the_list: Array<ValueLabel>
        the_list = new Array<ValueLabel>();

        if (this.props.UserState.UniversityListDetailedDistrictReport !== undefined) {
            this.props.UserState.UniversityListDetailedDistrictReport.forEach(x => {
                if (this.props.UserState["qa_account"] === "Y" || this.props.UserState.display_id == x.display_id || (x.detail_ids !== undefined && x.detail_ids != null && x.detail_ids.includes(this.props.UserState.display_id)))
                    the_list.push({ value: +x.display_id, label: x.university, isDisabled: false });
            })
        }
        return sortUniversity(the_list);
    }

    getFactSheetList() {
        let the_list: Array<ValueLabel>
        the_list = new Array<ValueLabel>();

        if (this.props.UserState.FactSheetList !== undefined) {
            this.props.UserState.FactSheetList.forEach(x => {
                if (this.props.UserState["qa_account"] === "Y" || this.props.UserState.display_id == x.display_id || (x.detail_ids !== undefined && x.detail_ids != null && x.detail_ids.includes(this.props.UserState.display_id)))
                    the_list.push({ value: +x.display_id, label: x.the_university.replace("the ", ""), isDisabled: false });
            })
        }
        return sortUniversity(the_list);
    }

    getSelectedValueECR() {
        var selectedSchool = this.getUniversityListECR().filter(x => { return (x.value === +this.props.UserState.report_display_id); });
        if (selectedSchool !== undefined && selectedSchool.length > 0) return selectedSchool[0].label;
    }
    getSelectedValueImpactFinder() {
        var selectedSchool = this.getUniversityListImpactFinder().filter(x => { return (x.value === +this.props.UserState.report_display_id); });
        if (selectedSchool !== undefined && selectedSchool.length > 0) return selectedSchool[0].label;
    }
    getSelectedValueSpendingReport() {
        var selectedSchool = this.getUniversityListSpendingReport().filter(x => { return (x.value === +this.props.UserState.report_display_id); });
        if (selectedSchool !== undefined && selectedSchool.length > 0) return selectedSchool[0].label;
    }
    getSelectedValueStateReport() {
        var selectedSchool = this.getUniversityListStateReport().filter(x => { return (x.value === +this.props.UserState.report_display_id); });
        if (selectedSchool !== undefined && selectedSchool.length > 0) return selectedSchool[0].label;
    }
    getSelectedValueVendorReport() {
        var selectedSchool = this.getUniversityListVendorReport().filter(x => { return (x.value === +this.props.UserState.report_display_id); });
        if (selectedSchool !== undefined && selectedSchool.length > 0) return selectedSchool[0].label;
    }
    getSelectedValueEmployeeReport() {
        var selectedSchool = this.getUniversityListEmployeeReport().filter(x => { return (x.value === +this.props.UserState.report_display_id); });
        if (selectedSchool !== undefined && selectedSchool.length > 0) return selectedSchool[0].label;
    }

    getSelectedValueSBEmployeeReport() {
        var selectedSchool = this.getUniversityListSBEmployeeReport().filter(x => { return (x.value === +this.props.UserState.report_display_id); });
        if (selectedSchool !== undefined && selectedSchool.length > 0) return selectedSchool[0].label;
    }

    getSelectedValueCTSAReport() {
        var selectedSchool = this.getUniversityListCTSAReport().filter(x => { return (x.value === +this.props.UserState.report_display_id); });
        if (selectedSchool !== undefined && selectedSchool.length > 0) return selectedSchool[0].label;
    }

    getSelectedValueFactSheet() {
        var selectedSchool = this.getFactSheetList().filter(x => { return (x.value === +this.props.UserState.report_display_id); });
        if (selectedSchool !== undefined && selectedSchool.length > 0) return selectedSchool[0].label;
    }

    getSelectedValueDetailedDistrict() {
        var selectedSchool = this.getDetailedDistrictList().filter(x => { return (x.value === +this.props.UserState.report_display_id); });
        if (selectedSchool !== undefined && selectedSchool.length > 0) return selectedSchool[0].label;
    }

    public render() {
        console.log(this.props.UserState)
        let universitylist_options_ecr = this.getUniversityListECR();
        let universitylist_options_impactfinder = this.getUniversityListImpactFinder();
        let universitylist_options_spendingreport = this.getUniversityListSpendingReport();
        let universitylist_options_statereport = this.getUniversityListStateReport();
        let universitylist_options_employeereport = this.getUniversityListEmployeeReport();
        let universitylist_options_sb_employeereport = this.getUniversityListSBEmployeeReport();
        let universitylist_options_vendorreport = this.getUniversityListVendorReport();
        let universitylist_options_CTSAreport = this.getUniversityListCTSAReport();
        let universitylist_options_factsheet = this.getFactSheetList();
        let universitylist_options_detaileddistrict = this.getDetailedDistrictList();
        
        console.log(this.props.UserState)
        console.log(this.getUniversityListSpendingReport())
        console.log(this.getSelectedValueSpendingReport())

        const {
            hide_impactfinder,
            hide_spending,
            hide_sb_employee,
            hide_employee,
            hide_vendor,
            hide_state,
            hide_congress,
            hide_one_district,
            hide_early_career,
            hide_congress_SB,
            hide_state_SB
        } = this.props.UserState;

        const userNameLowerCase = this.props.UserState.username.toLowerCase();

        let showImpactFinder = this.props.UserState.UniversityListImpactFinder?.find(x => x.display_id == this.props.UserState.display_id) != undefined
        if (hide_impactfinder && !userNameLowerCase.startsWith("iris_admin"))
            showImpactFinder = false;

        let showECR = this.props.UserState.UniversityListECR?.find(x => x.display_id == this.props.UserState.display_id) != undefined
        if (hide_early_career && !userNameLowerCase.startsWith("iris_admin"))
            showECR = false;
        
        let showStateReport = this.props.UserState.UniversityListStateReport?.find(x => x.display_id == this.props.UserState.display_id) != undefined
        if (hide_state_SB && !userNameLowerCase.startsWith("iris_admin"))
            showStateReport = false;

        let showCongressReport = this.props.UserState.FactSheetList?.find(x => x.display_id == this.props.UserState.display_id) != undefined
        if (hide_congress_SB && !userNameLowerCase.startsWith("iris_admin"))
            showCongressReport = false;


        const display_id = this.props.UserState.display_id;
        //const showStateReport = (display_id == "999040" || display_id == "76214" || display_id == "69211" || display_id == "54791" || display_id == "32964" || display_id == "81509");

        let showCensusEmployeeReport = this.props.UserState.UniversityListEmployeeReport?.find(x => x.display_id == this.props.UserState.display_id) != undefined
        let showSpendingReport = this.props.UserState.UniversityListSpendingReport?.find(x => x.display_id == this.props.UserState.display_id) != undefined
        if (hide_spending && !userNameLowerCase.startsWith("iris_admin"))
            showSpendingReport = false;


        let showVendorReport = this.props.UserState.UniversityListVendorReport?.find(x => x.display_id == this.props.UserState.display_id) != undefined
        if (hide_vendor && !userNameLowerCase.startsWith("iris_admin"))
            showVendorReport = false;


        //let showVendorReport = (this.props.UserState["qa_account"] === "Y" || this.props.UserState.username.toLowerCase().startsWith("iris_admin"));

        let showDetailedDistrictReport = this.props.UserState.UniversityListDetailedDistrictReport?.find(x => x.display_id == this.props.UserState.display_id) != undefined
        if (hide_one_district && !userNameLowerCase.startsWith("iris_admin"))
            showDetailedDistrictReport = false;


        let showSBEmployeeReport = this.props.UserState.UniversityListSBEmployeeReport?.find(x => x.display_id == this.props.UserState.display_id) != undefined
        if (hide_sb_employee && !userNameLowerCase.startsWith("iris_admin"))
            showSBEmployeeReport = false;

        let showFactSheetReport = this.props.UserState.FactSheetList?.find(x => x.display_id == this.props.UserState.display_id) != undefined

        const spendingReleaseDate = this.props.UserState.UniversityListSpendingReport.find(x => String(x.display_id) === String(this.props.UserState.display_id))?.release_date
        const ddReleaseDate = this.props.UserState.UniversityListDetailedDistrictReport.find(x => String(x.display_id) === String(this.props.UserState.display_id))?.release_date
        const slReleaseDate = this.props.UserState.UniversityListStateReport.find(x => String(x.display_id) === String(this.props.UserState.display_id))?.release_date
        const fsReleaseDate = this.props.UserState.FactSheetList.find(x => String(x.display_id) === String(this.props.UserState.display_id))?.release_date
        const vReleaseDate = this.props.UserState.UniversityListVendorReport.find(x => String(x.display_id) === String(this.props.UserState.display_id))?.release_date
        const ecrReleaseDate = this.props.UserState.UniversityListECR.find(x => String(x.display_id) === String(this.props.UserState.display_id))?.release_date
        const sbeReleaseDate = this.props.UserState.UniversityListSBEmployeeReport.find(x => String(x.display_id) === String(this.props.UserState.display_id))?.release_date

        return <div className='reports container-fluid'>
            <div className="row">
                <div className="col-md-12">
                    <Heading value='Reports' />
                    <table className='reportstable table reportspanel'>
                        <thead>
                            <tr>
                                <th>Report</th>
                                <th></th>
                                <th>Date Released</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(this.props.UserState["qa_account"] === "Y" || showECR) && 
                                <tr>
                                    <td>
                                        <Select className="universitylistdropdown"
                                            name="report_display_id"
                                            value={{ value: this.props.UserState.report_display_id, label: this.getSelectedValueECR() }}
                                            options={universitylist_options_ecr}
                                            onChange={this.props.handleReportDisplayIdChange_ECR}
                                        />
                                    </td>
                                    <td>
                                        <NavLink style={{ display: "inline-block", marginTop: "8px", marginBottom: "5px" }} target='_blank' to={'/reports/early-career-report'}>View Early Career Report</NavLink>
                                        <SharedLinksList perPage={5} UserState={this.props.UserState} report_type={"early_career"} />
                                    </td>
                                    <td>{ecrReleaseDate}</td>
                                </tr>
                            }
                            {(this.props.UserState["qa_account"] === "Y" || showImpactFinder) &&
                                <tr>
                                    <td></td>
                                    <td>
                                        <NavLink target='_blank' to={'/impact-finder/'}>Impact Finder</NavLink>

                                    </td>
                                    {this.props.UserState["qa_account"] === "Y" &&
                                        <td>
                                            <Select className="universitylistdropdown"
                                                name="report_display_id"
                                                value={{ value: this.props.UserState.report_display_id, label: this.getSelectedValueImpactFinder() }}
                                                options={universitylist_options_impactfinder}
                                                onChange={this.props.handleReportDisplayIdChange_impactFinder}
                                            />
                                            <NavLink target='_blank' to={'/impact-finder'}>Open Impact Finder</NavLink>
                                        </td>
                                    }
                                    <td>April 2024</td>
                                </tr>
                            }
                            {(this.props.UserState["qa_account"] === "Y" || showVendorReport) &&
                                <tr>
                                    <td>
                                        <Select className="universitylistdropdown"
                                            name="report_display_id"
                                            value={{ value: this.props.UserState.report_display_id, label: this.getSelectedValueVendorReport() }}
                                            options={universitylist_options_vendorreport}
                                            onChange={this.props.handleReportDisplayIdChange_VendorReport}
                                        />
                                    </td>
                                    <td>
                                        <NavLink style={{ display: "inline-block", marginTop: "8px", marginBottom: "5px" }} target='_blank' to={'/reports/new-vendor-report'}>View Vendor Report</NavLink>
                                        <SharedLinksList perPage={5} UserState={this.props.UserState} report_type={"vendor_report"} />
                                    </td>
                                    <td>{vReleaseDate}</td>
                                </tr>
                            }
                            {(this.props.UserState["qa_account"] === "Y" || showSpendingReport) &&
                                <tr>
                                    <td>
                                        <Select className="universitylistdropdown"
                                            name="report_display_id"
                                            value={{ value: this.props.UserState.report_display_id, label: this.getSelectedValueSpendingReport() }}
                                            options={universitylist_options_spendingreport}
                                            onChange={this.props.handleReportDisplayIdChange_SpendingReport}
                                            placeholder="Select University"
                                        />
                                    </td>
                                    <td>
                                        <NavLink style={{ display: "inline-block", marginTop: "8px", marginBottom: "5px" }} target='_blank' to={'/reports/spending_report'}>View Spending Report</NavLink>
                                        <SharedLinksList perPage={5} UserState={this.props.UserState} report_type={"spending_report"} />
                                    </td>
                                    <td>{spendingReleaseDate}</td>
                                </tr>
                            }
                            {(this.props.UserState["qa_account"] === "Y" || showStateReport) &&
                                <tr>
                                    <td>
                                        <Select className="universitylistdropdown"
                                            name="report_display_id"
                                            value={{ value: this.props.UserState.report_display_id, label: this.getSelectedValueStateReport() }}
                                            options={universitylist_options_statereport}
                                            onChange={this.props.handleReportDisplayIdChange_StateReport}
                                            placeholder="Select University"
                                        />
                                    </td>
                                    <td>
                                        <NavLink style={{ display: "inline-block", marginTop: "8px", marginBottom: "5px" }} to={'/reports/factsheet/stateLegislative'}>View State Legislative Factsheet</NavLink>
                                    </td>
                                    <td>{slReleaseDate}</td>
                                </tr>
                            }
                            {(this.props.UserState["qa_account"] === "Y" || showDetailedDistrictReport) &&
                                <tr>
                                    <td>
                                        <Select className="universitylistdropdown"
                                            name="report_display_id"
                                            value={{ value: this.props.UserState.report_display_id, label: this.getSelectedValueDetailedDistrict() }}
                                            options={universitylist_options_detaileddistrict}
                                            onChange={this.props.handleReportDisplayIdChange_FactSheet_Detail}
                                            placeholder="Select University"
                                        />
                                    </td>
                                    <td>
                                        <NavLink style={{ display: "inline-block", marginTop: "8px", marginBottom: "5px" }} to={'/reports/congressional-district-detail-report'}>View Congressional District Detail Report</NavLink>
                                    </td>
                                    <td>{ddReleaseDate}</td>
                                </tr>
                            }
                            {(this.props.UserState["qa_account"] === "Y" || showCongressReport) &&
                                <tr>
                                    <td>
                                        <Select className="universitylistdropdown"
                                            name="report_display_id"
                                            value={{ value: this.props.UserState.report_display_id, label: this.getSelectedValueFactSheet() }}
                                            options={universitylist_options_factsheet}
                                            onChange={this.props.handleReportDisplayIdChange_FactSheet}
                                            placeholder="Select University"
                                        />
                                    </td>
                                    <td>
                                        <NavLink style={{ display: "inline-block", marginTop: "8px", marginBottom: "5px" }} to={'/reports/factsheet'}>View Congressional District Factsheet</NavLink>
                                    </td>
                                    <td>{fsReleaseDate}</td>
                                </tr>
                            }
                            {(this.props.UserState["qa_account"] === "Y" || showSBEmployeeReport) &&

                                <tr>
                                    <td>
                                        <Select className="universitylistdropdown"
                                            name="report_display_id"
                                            value={{ value: this.props.UserState.report_display_id, label: this.getSelectedValueEmployeeReport() }}
                                            options={universitylist_options_sb_employeereport}
                                            onChange={this.props.handleReportDisplayIdChange_EmployeeReport}
                                            placeholder="Select University"
                                        />
                                    </td>
                                    <td>
                                        <NavLink style={{ display: "inline-block", marginTop: "8px", marginBottom: "5px" }} target="_blank" to={'/reports/employee-report'}>View Employee Report</NavLink>
                                        <SharedLinksList perPage={5} UserState={this.props.UserState} report_type={"employee-report"} />
                                    </td>
                                    <td>{sbeReleaseDate}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>;
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            handleReportDisplayIdChange_ECR: handleReportDisplayIdChange_ECR,
            handleReportDisplayIdChange_SpendingReport: handleReportDisplayIdChange_SpendingReport,
            handleReportDisplayIdChange_impactFinder: handleReportDisplayIdChange_impactFinder,
            handleReportDisplayIdChange_EmployeeReport: handleReportDisplayIdChange_EmployeeReport,
            handleReportDisplayIdChange_VendorReport: handleReportDisplayIdChange_VendorReport,
            handleReportDisplayIdChange_CTSAReport: handleReportDisplayIdChange_CTSAReport,
            handleReportDisplayIdChange_FactSheet: handleReportDisplayIdChange_FactSheet,
            handleReportDisplayIdChange_FactSheet_Detail: handleReportDisplayIdChange_FactSheet_Detail,
            handleReportDisplayIdChange_StateReport: handleReportDisplayIdChange_StateReport,
            handleReportDisplayIdChange: handleReportDisplayIdChange,
            loadShareHistory: loadShareHistory
        }, dispatch
    )
}

const mapStateToProps_FilterAndUser = (state: ApplicationState) => ({
    //FilterState: state.filterProperties,
    UserState: state.userProperties
});


export default connect(
    mapStateToProps_FilterAndUser, // Selects which state properties are merged into the component's props
    matchDispatchToProps
)(Reports);


function sortUniversity(uniArr) {
    var sorted = uniArr.sort((a, b) => a.label > b.label ? 1 : -1);
    return sorted;

}
